import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../components/App.css";
import { Container } from "@mui/material";
import Accordion from "react-bootstrap/Accordion";
import axios from "axios";
import toast from "react-hot-toast";
import { ADMIN_BASE_URL } from "../config/config";

const FAQHelp = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await axios.get(`${ADMIN_BASE_URL}/faqs/public`);
        setFaqs(response.data || []);
      } catch (error) {
        toast.error("Failed to load FAQs");
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  return (
    <Container>
      <div className="faq-container">
        <h3 style={{ textAlign: "center", marginBottom: "2rem" }}>
          Frequently Asked Questions
        </h3>
        {loading ? (
          <p style={{ textAlign: "center" }}>Loading FAQs...</p>
        ) : faqs.length === 0 ? (
          <p style={{ textAlign: "center" }}>No FAQs available yet.</p>
        ) : (
          <Accordion defaultActiveKey="0">
            {faqs.map((faq, index) => (
              <Accordion.Item eventKey={String(index)} key={faq._id}>
                <Accordion.Header>{faq.question}</Accordion.Header>
                <Accordion.Body>{faq.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        )}
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <p>Still not found what you were looking for?</p>
          <Link to="/user/support">Raise your ticket now to get help</Link>
        </div>
      </div>
    </Container>
  );
};

export default FAQHelp;
